import { useCallback, useEffect, useState } from 'react';

export const useDrawerTop = () => {
	const drawer = document.querySelector('.ant-drawer-content');
	const [top, setTop] = useState(true);

	const scrollHandler = useCallback(() => {
		if (drawer) {
			drawer.scrollTop > 1 ? setTop(false) : setTop(true);
		}
	}, [drawer]);

	useEffect(() => {
		if (drawer) {
			drawer.addEventListener('scroll', scrollHandler);
			return () => drawer.removeEventListener('scroll', scrollHandler);
		}
	}, [drawer, scrollHandler]);

	const scrollToTop = () => {
		if (drawer)
			drawer.scrollTo({
				top: 0,
			});
	};
	return {
		scrollToTop,
		top,
	};
};
